angular.module('callX').controller('DashboardCtrl', ['$scope', 'UserService', 'ReportsService', 'DateService', '$state', function($scope, UserService, ReportsService, DateService, $state) {

    $scope.dashboardTopData = {
        data: { data: [], label: '', points: { show: true, radius: 3}, stack: false, lines: { show: true,  fill: 1, fillColor: { colors: [{ opacity: 0.9 }, { opacity: 0.9}] } } }
    };

    $scope.rankBy = "revenue";

    $scope.chartOptions = {};

    $scope.tableContentLoading = false;
    $scope.Math = window.Math;

    var init = function(){
//        console.log(DateService.getDateObj());
        var TempDateObj = DateService.getDateObj();
        if(TempDateObj.timezone!=undefined){
            $scope.fetchDashboardData(TempDateObj.activeDate, TempDateObj.dateRangeValue);
        }
    };

    var dataArray_one = [
        { data: [[0,7],[1,6.5],[2,12.5],[3,7],[4,9],[5,6],[6,11],[7,6.5],[8,8],[9,7]], label: 'A', points: { show: true }, lines: { show: true, fill: true, fillColor: { colors: [{ opacity: 0. }, { opacity: 0.1}] } } },
        { data: [[0,4],[1,4.5],[2,7],[3,4.5],[4,3],[5,3.5],[6,6],[7,3],[8,4],[9,3]], label: 'B', points: { show: true }, lines: { show: true, fill: true, fillColor: { colors: [{ opacity: 0.1 }, { opacity: 0.1}] } } }
    ];

    $scope.toggleRankBy = function(rankBy){
        $scope.chartOptions.list = [];
        $scope.rankBy = rankBy;
        init();
    };

    $scope.plotBy = function(activeDate){
        if(activeDate === 'today' || activeDate === 'yesterday'){
            return 'hour';
        }
        else if(activeDate === 'thirty-days' || activeDate === 'seven-days' || activeDate === 'this-month'){
            return 'day';
        }
        else if(activeDate === 'this-year'){
            return 'month';
        }
        else{
            return 'hour';
        }
    };

    var fetchDashboardTopData = function(activeDate, dateRangeValue){
        var callbacks = {
            success: function(data) {
                $scope.dashboardTopData = data.data;
            },
            failure: function(data) {

            }
        };
        ReportsService.getDashboardTopData('campaigns', activeDate, dateRangeValue, callbacks);
    };

    $scope.orderParam = 'revenue';
    $scope.reverse = true;
    $scope.order = function(orderParam) {
//        console.log("Here!", orderParam);
        $scope.reverse = ($scope.orderParam === orderParam) ? !$scope.reverse : false;
        $scope.orderParam = orderParam;
    };

    var setViewData = function(data){
        $scope.tableData = data.data.list;
        $scope.tableData.totals = {
            calls: 0,
            repeat_calls: 0,
            unique_calls: 0,
            paid_calls: 0,
            conv: 0,
            unique_conv: 0,
            revenue: 0,
            rpc: 0,
            avg_connect_duration: 0
        };
        for(var i = 0; i < $scope.tableData.length; i++){
            $scope.tableData.totals.calls += $scope.tableData[i].calls;
            $scope.tableData.totals.repeat_calls += $scope.tableData[i].repeat_calls;
            $scope.tableData.totals.unique_calls += $scope.tableData[i].unique_calls;
            $scope.tableData.totals.paid_calls += $scope.tableData[i].paid_calls;
            $scope.tableData.totals.conv += $scope.tableData[i].conv;
            $scope.tableData.totals.unique_conv += $scope.tableData[i].unique_conv;
            $scope.tableData.totals.revenue += $scope.tableData[i].revenue;
            $scope.tableData.totals.rpc += $scope.tableData[i].rpc;
        }
        $scope.tableData.totals.conv = $scope.tableData.totals.conv / $scope.tableData.length;
        $scope.tableData.totals.unique_conv = $scope.tableData.totals.unique_conv / $scope.tableData.length;
        var graphData = data.data.chart;
        var list_items_array = [];
        for (var key in graphData) {
            if (graphData.hasOwnProperty(key)) {
                var list_item = { data: [], label: '', points: { show: true, radius: 3}, stack: false, lines: { show: true,  fill: 1, fillColor: { colors: [{ opacity: 0.1 }, { opacity: 0.1}] } } };
                list_item.data = graphData[key];
                list_item.label = key;
                list_items_array.push(list_item);
            }
        }
        $scope.chartOptions.list = list_items_array;
    };

    var fetchGraphAndTableData = function(activeDate, dateRangeValue){
        $scope.tableContentLoading = true;
        var callbacks = {
            success: function(data) {
                setViewData(data);
                $scope.tableContentLoading = false;
            },
            failure: function(data) {
                $scope.tableContentLoading = false;

            }
        };
        ReportsService.getGraphAndTableData('campaigns', activeDate, dateRangeValue, $scope.rankBy, callbacks);
    };

    $scope.fetchDashboardData = function(activeDate, dateRangeValue){
        fetchDashboardTopData(activeDate, dateRangeValue);
        fetchGraphAndTableData(activeDate, dateRangeValue);
    };

    $scope.getPromoCodeGranularData = function(name, gId, callType, state, dayPart){
        var currentUserData = UserService.getCurrentUserData();
        $state.go('app.reports.promo-granular', { 'userId': currentUserData.id, 'rankBy': $scope.rankBy, 'state': state, 'dayPart': dayPart, 'activeData': 'campaigns', 'gId': gId, 'callType': callType, 'name': name  });
    };

    $scope.$on('dateObjUpdate', function(event, dateObj) {
        $scope.fetchDashboardData(dateObj.activeDate, dateObj.dateRangeValue);
    });

    var getIndexFromId = function(id){
        var idx = -1;
        for(var i = 0; i < $scope.tableData.length; i++){
            if ($scope.tableData[i].id == id){
                idx = i;
                break;
            }
        }
        return idx;
    };

    var processingGeoLocData = false;
    $scope.getGeoLocsForCampaign = function(campaignId){
        var index = getIndexFromId(campaignId);
//        console.log("$scope.tableData[index].showGeoLocs",$scope.tableData[index].showGeoLocs);
        if(!$scope.tableData[index].showGeoLocs && !processingGeoLocData){
            processingGeoLocData = true;
            $scope.tableData[index].processingDrillDownData = true;
            var currentDateObj = DateService.getDateObj();
            var currentUserData = UserService.getCurrentUserData();
            var callbacks = {
                success: function(data) {
//                    console.log("Drilldown Data", data);
                    if(data.data!=undefined){
                        $scope.tableData[index].geoLocData = data.data.list;
                    }
                    else{
                        $scope.tableData[index].geoLocData=[];
                    }
                    $scope.tableData[index].showGeoLocs = true;
                    if($scope.tableData[index].showDayParting){
                        $scope.tableData[index].showDayParting = false;
                    }
                    processingGeoLocData = false;
                    $scope.tableData[index].processingDrillDownData = false;
                },
                failure: function(data) {
                    processingGeoLocData = false;
                    $scope.tableData[index].processingDrillDownData = false;
                }
            };
            ReportsService.getGeoData(currentUserData.id, 'campaigns', currentDateObj.activeDate, currentDateObj.dateRangeValue, campaignId, callbacks)
        }
        else{
            $scope.tableData[index].showGeoLocs = false;
        }
    };

    var processingDayPartingData = false;
    $scope.getDayPartingDataForCampaign = function(campaignId){
        var index = getIndexFromId(campaignId);
        if(!$scope.tableData[index].showDayParting && !processingDayPartingData) {
            processingDayPartingData = true;
            $scope.tableData[index].processingDrillDownData = true;
            var currentDateObj = DateService.getDateObj();
            var currentUserData = UserService.getCurrentUserData();
            var callbacks = {
                success: function (data) {
//                    console.log("Time Drilldown Data", data);
                    if(data.data!=undefined){
                        $scope.tableData[index].dayPartingData = data.data.list;
                    }
                    else{
                        $scope.tableData[index].dayPartingData=[];
                    }
                    $scope.tableData[index].showDayParting = true;
                    processingDayPartingData = false;
                    if($scope.tableData[index].showGeoLocs){
                        $scope.tableData[index].showGeoLocs = false;
                    }
                    $scope.tableData[index].processingDrillDownData = false;
                },
                failure: function (data) {
                    processingDayPartingData = false;
                    $scope.tableData[index].processingDrillDownData = false;
                }
            };
            ReportsService.getDayPartData(currentUserData.id, 'campaigns', currentDateObj.activeDate, currentDateObj.dateRangeValue, campaignId, callbacks)
        }
        else{
            $scope.tableData[index].showDayParting = false;
        }
    };

    init();


}]);